module.exports = __webpack_public_path__ + "static/media/iphone6s_white.4940573c.png";